import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  subtext?: string;
  variant?: 'primary' | 'ghost';
  className?: string;
}
export function CTAButton({
  text = 'Sí, quiero mi guía completa',
  subtext,
  variant = 'primary',
  className = ''
}: CTAButtonProps) {
  const base = variant === 'primary' ? 'bg-olive-600 hover:bg-olive-700 text-cream-50 animate-soft-pulse' : 'bg-cream-50 hover:bg-cream-100 text-olive-700 border-2 border-olive-600';
  return <a href="https://impulsodigital.vip/cart/44742359646294:1" className={`block w-full max-w-md mx-auto group ${className}`} data-id="element-50">
      <button className={`relative w-full font-sans font-semibold text-base md:text-lg py-4 md:py-5 px-6 rounded-full transition-all duration-300 hover:translate-y-[-1px] flex items-center justify-center gap-3 ${base}`} data-id="element-51">
        <span data-id="element-52">{text}</span>
        <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-53" />
      </button>
      {subtext && <p className="text-xs text-ink-600 text-center mt-3 font-medium" data-id="element-54">
          {subtext}
        </p>}
    </a>;
}